if (!customElements.get('bhatti-gift-slider')) {
  customElements.define('bhatti-gift-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bgift-slider-track');
      this.controls = this.querySelector('.bgift-slider-controls');
      if (!this.track || !this.controls) return;
      this.onClick = (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const slide = this.track.querySelector('.bgift-slide');
        const step = slide.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
        this.track.scrollBy({ left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.onSelect = (event) => {
        const slide = event.target.closest('.bgift-slide');
        if (slide && this.contains(slide)) this.track.scrollLeft += slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 2;
        this.controls.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 2;
        this.controls.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft >= max - 2;
      };
      this.controls.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onSelect);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controls?.removeEventListener('click', this.onClick);
      this.track?.removeEventListener('scroll', this.update);
      this.removeEventListener('shopify:block:select', this.onSelect);
    }
  });
}
